import {
  formatProductIdWithDots,
  formatWithCommas,
} from "@coworker/reusable/formatters/product.formatter";
import { ItemProductType } from "@coworker/apprestructured/src/scan-and-search/types/SikSearchResponseType";
import {
  Item,
  ItemSalesPrice,
} from "@coworker/apprestructured/src/shared/types/item";

export function parseSIKItem(item: ItemProductType) {
  return {
    source: "SIK",
    hfbNo: item.businessStructure.homeFurnishingBusinessNo,
    paNo: item.businessStructure?.productAreaNo,
    noFormatted: formatProductIdWithDots(item.itemNo),
    type: item.itemType,
    name: item.name,
    no: item.itemNo,
    smallImageUrl: item?.mainImageUrl,
    imageUrl: item?.mainImageUrl,
    description: formatWithCommas([
      item.typeName,
      item.validDesignText,
      item.itemMeasureReferenceText,
    ]),
    productTypeName: item.typeName,
    salesPrice: item.salesPrice
      ? ({
          price: item.salesPrice.numeral,
          currency: item.salesPrice.currencyCode,
          previous: {
            price: item.salesPrice?.previous?.wholeNumber,
          },
        } as ItemSalesPrice)
      : undefined,
    measurements: item.itemMeasureReferenceText,
  } as Item;
}
